import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
// import Typography from '@material-ui/core/Typography';
// import RemoveIcon from '@material-ui/icons/Remove';
// import CheckIcon from '@material-ui/icons/Check';

import './CodeSystemDialogData.css';

const useStyles = makeStyles({
	root: {
		width: '100%',
		height: '100%',
	},
});

function displayString(x) {
	if (x !== undefined) {
		return x;
	} else {
		return <span className="nullItem">null</span>;
	}
}

function displayBoolean(x) {
	if (x !== undefined) {
		if (x) {
			return 'true';
		} else {
			return 'false';
		}
	} else {
		return <span className="nullItem">null</span>;
	}
}

function displayProperty(title, rawValue) {
	var value = '';

	switch (typeof rawValue) {
		case 'string':
			value = displayString(rawValue);
			break;
		case 'boolean':
			value = displayBoolean(rawValue);
			break;
		case 'number':
			value = displayString(rawValue);
			break;
		case 'undefined':
			value = displayString(rawValue);
			break;
		default:
			console.log(typeof rawValue);
			value = 'XXX';
	}

	return (
		<div className="csDialogData__itemContainer">
			<div className="csDialogData__itemLabel">{title}</div>
			<div className="csDialogData__itemValue">{value}</div>
		</div>
	);
}

function displayContactName(name) {
	if (name !== null && name !== undefined) {
		return <div className="csDialogData__itemContainer">
			<div className="csDialogData__itemLabel Underlined">name</div>
			<div className="csDialogData__itemValue Underlined">{name}</div>
		</div>
	} else {
		return <div className="csDialogData__itemContainer">
			<div className="csDialogData__itemLabel Underlined">name</div>
			<div className="csDialogData__itemValue Underlined"><span className="nullItem">null</span></div>
		</div>
	}
}

function displayContactDetail(telecom) {
	if (telecom !== null && telecom !== undefined) {
		return telecom.map((x) => (
			<div className="csDialogData__itemContainer">
				<div className="csDialogData__itemLabel ">{displayNullCheck(x.system)}</div>
				<div className="csDialogData__itemValue">{displayNullCheck(x.value)}</div>
			</div>
		));
	}
}

function displayNullCheck(value) {
	if (value !== null && value !== undefined) {
		return value
	} else {
		return <span className="nullItem">null</span>
	};
}

function displayContacts(contact) {
	if (contact !== undefined) {
		return contact.map((x) => (
			<React.Fragment>
				{displayContactName(x.name)}
				{displayContactDetail(x.telecom)}
			</React.Fragment>
		));


	} else {
		return <div className="csDialogData__itemContainer">
			<span className="nullItem">null</span>
		</div>

	}
}

export default function CodeSystemDialogData(props) {
	const classes = useStyles();

	useEffect(() => {
		if (props) {
			// console.log('props', props);
		}
	});

	return (
		<Paper className={classes.root}>
			<div className="csDialogData">
				<div className="csDialogData__left">
					{displayProperty('url', props.url)}
					{displayProperty('version', props.version)}
					{displayProperty('status', props.status)}
					{displayProperty('name', props.name)}
					{displayProperty('title', props.title)}
					{displayProperty('experimental', props.experimental)}
					{displayProperty('date', props.date)}
					{displayProperty('publisher', props.publisher)}
					{/* // Contact */}
					{displayProperty('description', props.description)}
					{/* // useContext */}
					{displayProperty('jurisdiction', props.jurisdiction)}
					{displayProperty('purpose', props.purpose)}
					{displayProperty('copyright', props.copyright)}
					{displayProperty('case sensitive', props.caseSensitive)}
					{/* // valueSet */}
					{displayProperty('hierarchy meaning', props.hierarchyMeaning)}
					{displayProperty('compositional', props.compositional)}
					{displayProperty('versionNeeded', props.versionNeeded)}
					{displayProperty('content', props.content)}
					{/* // supplements */}
					{displayProperty('count', props.count)}
				</div>
				<div className="csDialogData__right">
					<div className="csDialogData__itemContainer">
						<div className="csDialogData__itemTitle">Contacts</div>

					</div>
					{displayContacts(props.contact)}
					{/* <div className="csDialogData__itemContainer">
						<div className="csDialogData__itemTitle">Properties</div>
					</div>

					<div className="csDialogData__itemContainer">
						<div className="csDialogData__itemTitle">Designations</div>
					</div> */}
				</div>
			</div>
		</Paper>
	);
}
